import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: ['./servicios.component.css']
})
export class ServiciosComponent implements OnInit {

  car:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, necesito su ayuda para solicitar una Póliza de Seguros de vehículos.';
  viaje:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, necesito su ayuda para solicitar una Póliza de Seguros de viajes.';
  prop:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, necesito su ayuda para solicitar una Póliza de Seguros de propiedades.';
  salud:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, necesito su ayuda para solicitar una Póliza de Seguros de salud.';
  vida:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, necesito su ayuda para solicitar una Póliza de Seguros de vida.';
  corpo:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, me gustaría saber más información sobre sus servicios empresariales.';
  alternos:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, me gustaría saber más información sobre sus servicios de canales alternos.';

  url:string = 'cotiza?p=';

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

  //abrir wassap
  goWhatapp(open:string){
    window.open(open, "_blank");
  }

  //ir al formulario
  goToform(val:string){
    this.router.navigate(['/cotiza', { p: val } ])
  }
 
}
